export default [{
  path: '/stage/reservationList',
  name: 'stage-reservationList',
  redirect: '/stage/reservationList/allDay',
  title: '预约',
  component: () => import('@/views/stage/template/reservationList/index'),
  children: [{
    path: '/stage/reservationList/allDay',
    name: 'stage-allDay',
    title: '预约',
    component: () => import('@/views/publicVue/thirdPage/qbyy')
  }, {
    path: '/stage/reservationList/bespeakService',
    name: 'stage-bespeakService',
    title: '预约',
    component: () => import('@/views/stage/template/reservationList/template/bespeakService')
  }, {
    path: '/stage/reservationList/singleDay',
    name: 'stage-singleDay',
    title: '预约',
    component: () => import('@/views/publicVue/thirdPage/dtyy')
  }, {
    path: '/stage/reservationList/bespeakTechnician',
    name: 'stage-bespeakTechnician',
    title: '预约',
    component: () => import('@/views/stage/template/reservationList/template/bespeakTechnician')
  }]
}, {
  path: '/stage/addReservationList',
  name: 'stage-addReservationList',
  title: '新增预约',
  component: () => import('@/views/stage/template/reservationList/template/addRevation')
}, {
  path: '/stage/commentList',
  name: 'stage-commentList',
  title: '查看评价',
  component: () => import('@/views/stage/template/commentList/index')
}, {
  path: '/stage/commentAnalyse',
  name: 'stage-commentAnalyse',
  title: '评价分析',
  component: () => import('@/views/stage/template/commentAnalyse/index')
}, {
  path: '/stage/bulletinBoard',
  name: 'stage-bulletinBoard',
  title: '公告栏',
  component: () => import('@/views/stage/template/bulletinBoard/index')
}, {
  path: '/stage/bulletinManage',
  name: 'stage-bulletinManage',
  title: '公告管理',
  component: () => import('@/views/stage/template/bulletinManage/index')
}, {
  path: '/stage/coupon',
  name: 'stage-coupon',
  title: '优惠券',
  component: () => import('@/views/stage/template/coupon/index.vue')
}];

// Bulletin board
